module.exports = __webpack_public_path__ + "static/media/bannerBlackFriday10.8602b603.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blackfriday/bannerBlackFriday10.png
// module id = 204
// module chunks = 0